<template>
    <div>
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-12">
                        <h3>Recepcion Diaria Por Materia Prima</h3>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <select name="" id="" v-model="mes" class="form-control">
                            <option :value="m.id" v-for="m in meses" :key="m.id">{{m.texto}}</option>
                        </select>
                        
                        <!-- <input type="date" name="" id="" v-model="fecha"> -->
                    </div>
                    <div class="col">
                        <select name="" id="" v-model="anio" class="form-control">
                            <option :value="p.anio" v-for="p in periodos" :key="p.anio">{{p.anio}}</option>
                        </select>
                    </div>

                    <div class="col">
                        <v-select class="" :reduce="option => option.id" v-model="destinos_ids" :options="destinos" label="nombre" multiple>
                            <template v-slot:no-options="{ search, searching }">
                            <template v-if="searching">
                                No se Encontraron Resultados Para <em>{{ search }}</em>.
                            </template>
                            <em style="opacity: 0.5;" v-else>Escriba para Filtrar...</em>
                            </template>
                        </v-select>
                    </div>

                    <div class="col">
                        <button class="btn btn-primary btn-icon" @click="cargarDatos">Cargar</button>
                        <button class="btn btn-success btn-icon" @click="exportar_excel"><i class="fas fa-file-excel"></i> Excel</button>
                    </div>
                </div>

                <div class="row mt-5">
                    <div class="tableFixHead" style="width:100%" v-show="datos.length > 0">
                        <table class="table table-bordered">
                            <thead class="thead-skyblue2">
                                <tr>
                                    <th class="fixed background-salmon-1">Fecha</th>
                                    <th class="fixed background-salmon-1" v-for="m in materias_primas" :key="m.id">{{m.nombre}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="d in datos" :key="d.fecha">
                                    <td>{{d.fecha | fecha}}</td>
                                    <td v-for="m in d.materias_primas" :key="m.id" v-bind:class="{'text-red':m.mps_id == -2}">
                                        {{m.cantidad |formatear_miles}}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- <pre>{{mes}}</pre>
                <pre>{{anio}}</pre>
                <pre>{{inicio}}</pre>
                <pre>{{fin}}</pre>
                <pre>{{getDates}}</pre> -->

                
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
    data:()=>({
        meses:[
            {id:'01',texto:'Enero'},
            {id:'02',texto:'Febrero'},
            {id:'03',texto:'Marzo'},
            {id:'04',texto:'Abril'},
            {id:'05',texto:'Mayo'},
            {id:'06',texto:'Junio'},
            {id:'07',texto:'Julio'},
            {id:'08',texto:'Agosto'},
            {id:'09',texto:'Septiembre'},
            {id:'10',texto:'Octubre'},
            {id:'11',texto:'Noviembre'},
            {id:'12',texto:'Diciembre'},
        ],
        periodos:[],
        dia:new Date().toISOString().substring(8,10),
        mes:new Date().toISOString().substring(5,7),
        anio:new Date().toISOString().substring(0,4),
        fecha:new Date().toISOString().substring(0,10),
        datos:[],
        url_excel:null,
        materias_primas:[],
        destinos:[],
        destinos_ids:[]
    }),
    mounted(){
        this.cargar_destinos();
    },
    methods:{

        async cargar_destinos(){
          await this.axios.get(`${this.api}/destinos`,this.cabeceras_json,).then(res=>{
                this.destinos = res.data.data;
            }).catch(e=>{
                //console.log(e);
            });
            this.cargarPeriodos();
        },

        cargarPeriodos(){
          let min = new Date().getFullYear();
          min = min - 1;
          let max = min + 10;

          for (var i = min; i<=max; i++){
              this.periodos.push({anio:i});
          }
        },

        async cargarDatos(){
            let body = {
                headers:{
                    'Content-Type':'application/json;charset=utf-8',
                    Authorization:`${this.token}`
                },
                params:{
                    fechas:this.getDates,
                    destinos_ids:this.destinos_ids
                }
            }
            //this.$set(body,'params',{fechas:this.getDates})
            //body.params.fechas = this.getDates;
            console.log(body);
            await this.axios.get(`${this.api}/reportes/mensual_materia_prima`,body).then(res=>{
                this.datos = res.data.data.data;
                this.materias_primas = res.data.data.materias_primas;
                this.url_excel = res.data.data.url;
            }).catch(e=>{
                //console.log(e);
            });
        },

        devuelve_valor(mp_id,dato){
            return dato.materias_primas.find(m=>m.mps_id == mp_id).cantidad
        },

        async exportar_excel(){
            window.open(this.url_excel, '_blank');
        },

        
    },
    computed:{
        inicio(){
            return `${this.anio}-${this.mes}-01`;
        },
        fin(){
            return `${this.anio}-${this.mes}-${this.dia}`;
        },

        getDates() {
            var dateArray = [];
            var currentDate = this.$moment(this.inicio);
            var stopDate = this.$moment(this.inicio).endOf('month');
            
            //this.$moment(this.fin);
            while (currentDate <= stopDate) {
                dateArray.push( this.$moment(currentDate).format('YYYY-MM-DD') )
                currentDate = this.$moment(currentDate).add(1, 'days');
            }
            return dateArray;
        },

        ...mapState(['api','cabeceras_json','token'])
    }
}
</script>
<style>
.tableFixHead          { overflow: auto; height: 600px; }
.tableFixHead thead th { position: sticky; top: 0; z-index: 1; }

/* Just common table stuff. Really. */
table  { border-collapse: collapse; width: 100%; }
th, td { padding: 8px 16px; }
th     { background:#427391; color:#fff }

</style>